import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
    Box, Button, Card, CardHeader, CardContent, Collapse, Typography, Grid
} from '@material-ui/core'
import componentStyles from 'assets/theme/views/admin/react-bs-table.js'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ProjectPreviewCard from './ProjectPreviewCard'
import AddProjectCard from './AddProjectCard'
import MissingInfoDialog from './MissingInfoDialog'

const useStyles = makeStyles(componentStyles)

function CaseStudiesCard({ company, updateCompany, updateField, newProjectDraft, submitProfile, admin=false, profile=false }) {
    const classes = { ...useStyles() }
    const [open, setOpen] = useState(true)

    const [showAddDialog, setShowAddDialog] = useState(false)
    const [showMissingFields, setShowMissingFields] = useState(false)
    const [missingFields, setMissingFields] = useState([])

    const projects = company?.projects || []

    function getMissingFields() {
        if (!projects || projects.length === 0) {
            return [{ key: 'projects', label: 'At least one case study is required' }]
        }
        return []
    }

    function handleSubmitProfile() {
        // If admin, bypass missing field validation entirely
        let proceed = true
        if (!admin) {
            const missing = getMissingFields()
            if (missing.length > 0) {
                setMissingFields(missing)
                setShowMissingFields(true)
                proceed = false
            }
        }
        if (!proceed) return

        submitProfile()
    }

    function previewProfile() {
        const previewUrl = `https://installers.energyefficiency.ie/preview-profile?slug=${company.slug}`;
        console.log('Preview URL:', previewUrl);
        window.open(previewUrl, '_blank', 'noopener,noreferrer');
    }

    return (
        <Card>
            <CardHeader
                subheader={
                    <>
                        <Box display='flex' style={{ justifyContent: 'space-between' }}>
                            <Box>
                                <Box
                                    component={Typography}
                                    variant='h2'
                                    marginBottom='0!important'
                                >
                                    <Box component='span'>Case Studies</Box>
                                </Box>
                                <Box
                                    component='p'
                                    fontSize='.875rem'
                                    marginBottom='0'
                                    marginTop='0'
                                    lineHeight='1.7'
                                    fontWeight='300'
                                >
                                    Showcase case studies on your profile
                                </Box>
                            </Box>
                        </Box>
                    </>
                }
                onClick={() => setOpen(o => !o)}
                style={{ cursor: 'pointer' }}
                action={<ExpandMoreIcon style={{ transform: open ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s', marginTop: 4 }} />}
                classes={{ root: classes.cardHeaderRoot }}
            />
            <Collapse in={open}>
            <CardContent>
                <Grid container spacing={2}>
                    {projects.length > 0 ? (
                        projects.map((project) => (
                            <Grid item xs={12} key={project.projectId}>
                                <ProjectPreviewCard
                                    companyDetails={company}
                                    project={project}
                                    updateCompany={updateCompany}
                                    updateField={updateField}
                                />
                            </Grid>
                        ))
                    ) : (
                        <Grid item xs={12}>
                            <Typography color="textSecondary" align="center">
                                No case studies
                            </Typography>
                        </Grid>
                    )}

                    <Grid item xs={12} style={{marginTop: '1rem'}}>
                        <Box display='flex' justifyContent='space-between'>
                            <Button
                                variant='outlined'
                                color='primary'
                                onClick={() => setShowAddDialog(true)}
                            >
                                Add Case Study
                            </Button>
                            {!(admin || profile) ? (
                                <Button
                                    variant='contained'
                                    color='primary'
                                    onClick={handleSubmitProfile}
                                >
                                    Submit Profile
                                </Button>
                            ) : (
                                <Button
                                    variant='contained'
                                    color='primary'
                                    onClick={previewProfile}
                                >
                                    Preview Profile
                                </Button>
                            )}
                        </Box>
                    </Grid>
                </Grid>
            </CardContent>
            </Collapse>
            <AddProjectCard
                open={showAddDialog}
                onClose={() => setShowAddDialog(false)}
                companyId={company.companyId}
                newProjectDraft={newProjectDraft || {}}
                updateField={updateField}
                updateCompany={updateCompany}
            />
            <MissingInfoDialog
                open={showMissingFields}
                onClose={() => setShowMissingFields(false)}
                missingFields={missingFields}
            />
        </Card>
    )
}

export default CaseStudiesCard